export const invoicepaidColumns = (handleViewInvoice, page, size) => [
    {
        name: <h4>Sl.No</h4>,
        selector: (row, index) =>(page - 1) * size + index + 1,
        width: "100px",
    },
    {
        name: <h4>Invoice Number</h4>,
        selector: (row) => row.invoice_number,
        sortable: true,
        wrap: true,
    },
    {
        name: <h4>Invoice Date</h4>,
        selector: (row) => row.invoice_date,
        sortable: true,
        wrap: true,
    },
    {
        name: <h4>Due/Start Date</h4>,
        selector: (row) => row.due_date,
        sortable: true,
        wrap: true,
    },

    {
        name: <h4>Invoice Status</h4>,
        selector: (row) => row.payment_status,
        sortable: true,
        cell: (row) => (
            <span
                className={`badge ${row.payment_status === "paid" ? "badge-success" : "badge-success"
                    }`}
                style={{
                    backgroundColor: "#ECFDF5",
                    color: row.payment_status === "paid" ? "#10B981" : "",
                    fontWeight: 400,
                    textTransform: "capitalize",
                }}
            >
                {row.payment_status}
            </span>
        ),
        center: true,
    },

    {
        name: <h4>Amount</h4>,
        selector: (row) => 'B$ ' + row.amount,
        sortable: true,
        wrap: true,
    },
    {
        name: <h4>Action</h4>,
        selector: (row) => row.action,
        sortable: true,
        cell: (row) => (
            <div className="d-flex">
                <span
                    onClick={() => handleViewInvoice(row?.id)}
                    className="btn btn-link"
                    style={{ color: "#534686", padding: "0.25rem 0.5rem" }}
                >
                    View
                </span>
            </div>
        ),
    },
];

export const invoiceUnpaidColumns = (handleViewInvoice, handlePayment, page, size) => [
    {
        name: <h4>Sl.No</h4>,
        selector: (row, index) =>(page - 1) * size + index + 1,
        width: "100px",
    },
    {
        name: <h4>Invoice Number</h4>,
        selector: (row) => row.invoice_number,
        sortable: true,
        wrap: true,
    },
    {
        name: <h4>Invoice Date</h4>,
        selector: (row) => row.invoice_date,
        sortable: true,
        wrap: true,
    },
    {
        name: <h4>Due/Start Date</h4>,
        selector: (row) => row.due_date,
        sortable: true,
        wrap: true,
    },

    {
        name: <h4>Invoice Status</h4>,
        selector: (row) => row.payment_status,
        sortable: true,
        cell: (row) => (
            <span
                className={`badge ${row.payment_status !== "paid" ? "badge-danger" : "badge-danger"
                    }`}
                style={{
                    backgroundColor: "#FEF2F2",
                    color: row.payment_status !== "paid" ? "#DF2935" : "",
                    fontWeight: 400,
                    textTransform: "capitalize",
                }}
            >
                {row.payment_status}
            </span>
        ),
        center: true,
    },

    {
        name: <h4>Amount</h4>,
        selector: (row) => 'B$ ' + row.amount,
        sortable: true,
        wrap: true,
    },
    {
        name: <h4>Action</h4>,
        selector: (row) => row.action,
        sortable: true,
        cell: (row) => (
            <div className="d-flex">
                <span
                    onClick={() => handleViewInvoice(row?.id)}
                    className="btn btn-link"
                    style={{ color: "#534686", padding: "0.25rem 0.5rem" }}
                >
                    View
                </span>

                {row.payment_status !== "paid" && (
                    <button
                        className="btn btn-success gradient-green ml-2"
                        style={{ padding: "1px 12px" }}
                        onClick={() => handlePayment(row)}
                    >
                        Pay
                    </button>
                )}
            </div>
        ),
        center: true,
    },
];

export const invoiceOrderColumns = (handleViewInvoice, page, size) => [
    {
        name: <h4>Sl.No</h4>,
        selector: (row, index) =>(page - 1) * size + index + 1,

        width: "100px",
    },
    {
        name: <h4>Invoice Number</h4>,
        selector: (row) => row.invoice_number,
        sortable: true,
        wrap: true,
    },
    {
        name: <h4>Invoice Date</h4>,
        selector: (row) => row.invoice_dt,
        sortable: true,
        wrap: true,
    },
    {
        name: <h4>Item Name</h4>,
        selector: (row) => row.orderItem?.map(item => item.name).join(', '),
        sortable: true,
        wrap: true,
    },

    {
        name: <h4>Order Status</h4>,
        selector: (row) => row.status,
        sortable: true,
        cell: (row) => (
            <span
                className={`badge ${row.status === "pending" ? "badge-danger" : "badge-success"
                    }`}
                style={{
                    backgroundColor: row.status === "pending" ? "#FEF2F2" : "#ECFDF5",
                    color: row.status === "pending" ? "#DF2935" : "#10B981",
                    fontWeight: 400,
                    textTransform: "capitalize",
                }}
            >
                {row.status}
            </span>
        ),
        center: true,
    },

    {
        name: <h4>Amount</h4>,
        selector: (row) => 'B$ ' + row.order_total,
        sortable: true,
        wrap: true,
    },
    {
        name: <h4>Action</h4>,
        selector: (row) => row.action,
        sortable: true,
        cell: (row) => (
            <div className="d-flex">
                <span
                    onClick={() => handleViewInvoice(row?.order_id)}
                    className="btn btn-link"
                    style={{ color: "#534686", padding: "0.25rem 0.5rem" }}
                >
                    View
                </span>
            </div>
        ),
    },
];